module.exports = __webpack_public_path__ + "static/img/382A4A_1_0.83fad45.svg";